import { Yield } from '../../abacus/interfaces/yield.interface'

export const programmingLanguageYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
